import { logger } from '@adornis/base/logging.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { sendWorkshopStornoMail } from '@chancenwerk/workshops/api/sendWorkshopStornoMail.js';
import { WorkshopAttendanceStatus } from '@chancenwerk/workshops/entities/WorkshopAttendanceStatus.js';
import { WorkshopTrainingAttendance } from '@chancenwerk/workshops/entities/WorkshopTrainingAttendance.js';
import type { WorkshopAttendance } from '../entities/WorkshopAttendance.js';

const selectionSet: BaseQLSelectionSet<WorkshopTrainingAttendance> = {
  date: 1,
  workshopID: 1,
  appointment: {
    _id: 1,
  },
  userID: 1,
};

export const stornoWorkshopAttendanceByAccessToken = registerMutation({
  type: () => Boolean,
  operationName: 'stornoWorkshopAttendanceByAccessToken',
  resolve: (accessToken: string) => {
    return async () => {
      const col = await getRawCollection<WorkshopTrainingAttendance>(WorkshopTrainingAttendance._collectionName);
      const attendanceID = (await col.findOne({ accessToken }, { projection: { _id: 1 } }))?._id;
      if (!attendanceID) {
        logger.warn(`No attendance found for accessToken: ${accessToken}`);
        return false;
      }

      const attendanceTraining = await WorkshopTrainingAttendance.getByID<WorkshopTrainingAttendance>(attendanceID)(
        selectionSet,
      );
      const attendance = await WorkshopTrainingAttendance.getByID<WorkshopAttendance>(attendanceID)(selectionSet);

      const found = attendanceTraining || attendance;
      if (!found?.appointment?._id || !found.userID) {
        logger.warn(`No appointment or userID found for attendance: ${attendanceID}`);
        return false;
      }

      found.state = WorkshopAttendanceStatus.CANCELLED;
      await found.save();
      await sendWorkshopStornoMail(found?.appointment?._id, found?.userID)();
      return true;
    };
  },
  options: {},
  params: [{ type: () => String, name: 'accessToken' }],
});
